<div class="row" style="margin-top: 100px;">
    <div class="col-md-12">
        <div class="card">
            <div class="card-header card-header-icon card-header-rose">
                <h3><i class="far fa-id-badge"></i> Lead Form</h3>
            </div>
            <div class="card-body">
                <div class="form-group mt-2">
                    <label for="firstName">First Name</label>
                    <input type="text" class="form-control" id="firstName" name="firstName" [(ngModel)]="lead.firstName" aria-describedby="firstName">
                </div>
                <div class="form-group mt-2">
                    <label for="lastName">Last Name</label>
                    <input type="text" class="form-control" id="lastName" name="lastName" [(ngModel)]="lead.lastName" aria-describedby="lastName">
                </div>
                <div class="form-group mt-2">
                    <label for="jobTitle">Job Title</label>
                    <input type="text" class="form-control" id="jobTitle" name="jobTitle" [(ngModel)]="lead.jobTitle" aria-describedby="jobTitle">
                </div>
                <div class="form-group mt-2">
                    <label for="email">Email</label>
                    <input type="text" class="form-control" id="email" name="email" [(ngModel)]="lead.email" aria-describedby="email">
                </div>
                <div class="form-group mt-2">
                    <label for="company">Company</label>
                    <input type="text" class="form-control" id="company" name="company" [(ngModel)]="lead.company" aria-describedby="company">
                </div>
                <div class="form-group mt-2">
                    <label for="market">Market</label>
                    <input type="text" class="form-control" id="market" name="market" [(ngModel)]="lead.market" aria-describedby="market">
                </div>
                <div class="form-group mt-2">
                    <label for="dateSubmitted">Date Submitted</label>
                    <input type="text" class="form-control" id="dateSubmitted" name="dateSubmitted" [(ngModel)]="lead.dateSubmitted" aria-describedby="dateSubmitted">
                </div>

                <!-- Toolbar -->
                <button type="submit" class="btn btn-primary mr-3" (click)="save()"><i class="fas fa-save"></i> Save</button>
                <button type="submit" class="btn btn-dark" (click)="back()"><i class="fas fa-backward"></i> Back</button>
            </div>
        </div>
    </div>
</div>